import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TeamsService } from '@teams/infra';
import { AssignGamesToTeamResponse } from '@core-http';
import { AssignGamesToTeamCommandPayload } from './assign-games-to-team.command-payload';
import { AssignGamesToTeamCommandResult } from './assign-games-to-team.command-result';

export class AssignGamesToTeamCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  assign(payload: AssignGamesToTeamCommandPayload): Observable<AssignGamesToTeamCommandResult> {
    return this.teamsService
      .assignGamesToTeam({ teamId: payload.teamId }, { gameIds: payload.gameIds })
      .pipe(map((dto: AssignGamesToTeamResponse) => this.mapToResult(dto)));
  }

  private mapToResult(dto: AssignGamesToTeamResponse): AssignGamesToTeamCommandResult {
    return {
      assignedCount: dto.assignedGameIds?.length ?? 0,
      alreadyAssignedCount: dto.alreadyAssignedGameIds?.length ?? 0,
      invitedMembersCount: dto.invitedMembersCount ?? 0
    };
  }
}
